import { GET_LOCATION_SUCCEEDED, GET_ALL_DESTINATION_SUCCEEDED } from "./edit.actions";
import * as _ from 'lodash';

export const edit = (state = { fetched: false, item: {} }, action) => {
    switch (action.type) {
        case GET_LOCATION_SUCCEEDED:
            return _.assign({}, state, { item: action.data, fetched: true });

        case  GET_ALL_DESTINATION_SUCCEEDED:
            return _.assign({}, state, { destinations: action.data, item: _.assign(state.item, { destination: _.find(action.data, item => item.getId() === (state as any).item.destination_id) }) });

        default:
            return state;
    }
};
